require('owl.carousel/dist/owl.carousel.js');
var component = require('../../../lib/js/component.js');
var customTabs = require('../../../lib/js/custom-tabs.js');
var utils = require("../../../lib/js/utils.js");

function AmenityOverview() {

    this.initialize = function (element) {

        this.initMobileCarousels();

        var tabs = document.querySelectorAll('.AmenityOverview [role="tab"]');
        var tabList = document.querySelector('.AmenityOverview [role="tablist"]');
      
        // Add a click event handler to each tab
        tabs.forEach(function (tab) {
          tab.addEventListener("click", function(e) {
            var target = e.currentTarget;
            var parent = target.parentNode;
          
            // Remove all current selected tabs
            parent
              .querySelectorAll('[aria-selected="true"]')
              .forEach(function(t) {
                t.setAttribute("aria-selected", false); 
                t.setAttribute("tabindex",-1)
              });
          
            // Set this tab as selected
            target.setAttribute("aria-selected", true);
            target.setAttribute("tabindex",0);
    
            // Hide all tab panels
            document
              .querySelectorAll('.AmenityOverview__image-container [role="tabpanel"]')
              .forEach(function(p){p.setAttribute("hidden", true)});
          
            var selector = target.getAttribute("aria-controls");
            // Show the selected panel
            document
              .querySelector(".AmenityOverview__image-container #"+selector)
              .removeAttribute('hidden');
              });
        });

        // Enable arrow navigation between tabs in the tab list
        var tabFocus = 0;
      
        tabList.addEventListener("keydown", function (e) {
          // Move right
          if (e.keyCode === 39 || e.keyCode === 37) {
            tabs[tabFocus].setAttribute("tabindex", -1);
            if (e.keyCode === 39) {
              tabFocus++;
              // If we're at the end, go to the start
              if (tabFocus >= tabs.length) {
                tabFocus = 0;
              }
              // Move left
            } else if (e.keyCode === 37) {
              tabFocus--;
              // If we're at the start, move to the end
              if (tabFocus < 0) {
                tabFocus = tabs.length - 1;
              }
            }
      
            tabs[tabFocus].setAttribute("tabindex", 0);
            tabs[tabFocus].focus();
          }
        });
 
        this.brand = $('body').data('brand');

        customTabs.createCustomTabEvents(this.$element);

        $(window).on("resize", utils.debounce(this.handleWindowResize.bind(this), 250, false));
    }

    this.isAmCarouselInitialized = function($carousel) {
        return $carousel.find('> .owl-stage-outer > .owl-stage > .owl-item .carousel__item').length > 0;
    }

    this.ensureMobileCarouselsInitialized = function() {
        var $owlCarousel = this.$element.find('.am-carousel');

        // Owl 2.3+ bails out of item setup when any descendant .owl-item exists (for
        // example if Carousel-v2 initialized before this module). Recover if needed.
        if ($owlCarousel.data('owl.carousel') && !this.isAmCarouselInitialized($owlCarousel)) {
            $owlCarousel.trigger('destroy.owl.carousel');
        }

        if (!$owlCarousel.data('owl.carousel')) {
            $owlCarousel.owlCarousel({
                checkVisibility: false,
                lazyLoad: true,
                loop: true,
                dots: false,
                margin: 10,
                autoHeight: true,
                nav: false,
                responsive: {
                    0: {
                        items: 1
                    }
                }
            });
        }

        var imageSlider = this.$element.find('.mobile-slider .image-slider');
        var arrowColor = imageSlider.data('arrowColor');
        var arrowBackgroundColor = imageSlider.data('arrowBackground');

        this.$element.find('.owl-carousel-2').each(function() {
            var $carousel = $(this);

            if ($carousel.data('owl.carousel')) {
                return;
            }

            $carousel.owlCarousel({
                checkVisibility: false,
                lazyLoad: true,
                loop: true,
                dots: false,
                margin: 10,
                nav: true,
                navText : ['<div class="icon-arrow-wrapper" style="border-color:' + arrowColor + '; background-color:' + arrowBackgroundColor + '"> <i class="icon-arrow-left" style="color:' + arrowColor + '"></i></div>',
                        '<div class="icon-arrow-wrapper" style="border-color:' + arrowColor + '; background-color:' + arrowBackgroundColor + '"> <i class="icon-arrow-right" style="color:' + arrowColor + '"></i></div>'],
                items: 1,
                autoHeight: true
            });
        });

        setTimeout(this.updateDesktopCarouselV2Colors.bind(this, arrowColor, arrowBackgroundColor), 0);

        return $owlCarousel;
    }

    this.initMobileCarousels = function() {
      var $element = this.$element;
      var $owlCarousel = this.ensureMobileCarouselsInitialized();

      $element.find('.slider-nav__next').on('click', function (event) {
          event.stopPropagation();
          $owlCarousel.trigger('next.owl.carousel');
          $element.find('.slider-nav__next').attr('data-analytics-cta', $element.find('.am-carousel .owl-item.active .carousel__item .info__heading')[0].innerHTML + "|next-button");
          $element.find('.slider-nav__next').attr('data-analytics', $element.find('.am-carousel .owl-item.active .carousel__item .info__heading')[0].innerHTML + "|next-button");
      });

      $element.find('.slider-nav__prev').on('click', function (event) {
          event.stopPropagation();
          $owlCarousel.trigger('prev.owl.carousel');
          $element.find('.slider-nav__prev').attr('data-analytics-cta', $element.find('.am-carousel .owl-item.active .carousel__item .info__heading')[0].innerHTML + "|prev-button");
          $element.find('.slider-nav__prev').attr('data-analytics', $element.find('.am-carousel .owl-item.active .carousel__item .info__heading')[0].innerHTML + "|prev-button");
      });
    }

    this.changeTabs = function(e) {
        var target = e.target;
        var parent = target.parentNode;
      
        // Remove all current selected tabs
        parent
          .querySelectorAll('[aria-selected="true"]')
          .forEach(function(t) {
            t.setAttribute("aria-selected", false); 
            t.setAttribute("tabindex",-1)
          });
      
        // Set this tab as selected
        target.setAttribute("aria-selected", true);
        target.setAttribute("tabindex",0);

        // Hide all tab panels
        document
          .querySelectorAll('.AmenityOverview__image-container [role="tabpanel"]')
          .forEach(function(p){p.setAttribute("hidden", true)});
      
        var selector = target.getAttribute("aria-controls");
        // Show the selected panel
        document
          .querySelector(".AmenityOverview__image-container #"+selector)
          .removeAttribute('hidden');
    }

    this.updateDesktopCarouselV2Colors = function(arrowColor, arrowBackgroundColor) {
        this.$element.find('.Carousel .icon-arrow-right').css('color', arrowColor);
        this.$element.find('.Carousel .icon-arrow-left').css('color', arrowColor);
        this.$element.find('.Carousel .owl-prev').css('border-color', arrowColor);
        this.$element.find('.Carousel .owl-next').css('border-color', arrowColor);
        this.$element.find('.Carousel .owl-prev').css('background-color', arrowBackgroundColor);
        this.$element.find('.Carousel .owl-next').css('background-color', arrowBackgroundColor);
    } 

    this.handleWindowResize = function(){
      var $element = this.$element;
      var carousels = $element.find(".carousel-2-wrapper");
      carousels.find(".owl-carousel").trigger("refresh.owl.carousel");

      var $amCarousel = $element.find('.am-carousel');
      if ($amCarousel.data('owl.carousel')) {
          $amCarousel.trigger('refresh.owl.carousel');
      } else if ($amCarousel.is(':visible')) {
          this.ensureMobileCarouselsInitialized();
      }

      if ($(window).outerWidth() < 1025) {
        $element.find('.slider-nav__next').attr('data-analytics-cta', $element.find('.am-carousel .owl-item.active .carousel__item .info__heading')[0].innerHTML + "|next-button");
        $element.find('.slider-nav__next').attr('data-analytics', $element.find('.am-carousel .owl-item.active .carousel__item .info__heading')[0].innerHTML + "|next-button");

        $element.find('.slider-nav__prev').attr('data-analytics-cta', $element.find('.am-carousel .owl-item.active .carousel__item .info__heading')[0].innerHTML + "|prev-button");
        $element.find('.slider-nav__prev').attr('data-analytics', $element.find('.am-carousel .owl-item.active .carousel__item .info__heading')[0].innerHTML + "|prev-button");
      }
    }

}

module.exports = component(AmenityOverview);